import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { ExpectedBillModel } from '../models/expected-bill.model';
import { ExpectedBillService } from '../services/expected-bill.service';

@Injectable()
export class ExpectedBillResolver implements Resolve<ExpectedBillModel> {

    constructor(private service: ExpectedBillService) 
    {

    }

    resolve(route: ActivatedRouteSnapshot): Observable<ExpectedBillModel> {
        return this.service.GetExpectedBill(route.params.expected_bill_id);
    }
}
